import React from 'react'

interface CarIconProps {
  className?: string
  size?: number
  color?: string
}

// Эконом - Компактный хэтчбек (как Kia Rio, Hyundai Solaris)
export const EconomCar: React.FC<CarIconProps> = ({ className = '', size = 80, color = '#a78bfa' }) => (
  <svg
    width={size}
    height={size * 0.4}
    viewBox="0 0 120 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Тень */}
    <ellipse cx="60" cy="46" rx="50" ry="2" fill="rgba(0,0,0,0.15)" />
    
    {/* Кузов */}
    <path
      d="M10 32 L18 20 C20 17 24 16 28 16 L72 16 C76 16 80 17 82 20 L98 32 L105 32 C108 32 110 34 110 36 L110 38 C110 40 108 42 105 42 L15 42 C12 42 10 40 10 38 L10 36 C10 34 10 32 10 32 Z"
      fill={color}
    />
    
    {/* Крыша */}
    <path
      d="M28 16 L36 6 C38 4 42 3 48 3 L62 3 C68 3 72 4 74 6 L82 16"
      fill={color}
      opacity="0.85"
    />
    
    {/* Окна */}
    <path
      d="M32 15 L38 7 C39 5.5 42 5 47 5 L54 5 L54 15 Z"
      fill="rgba(200, 200, 255, 0.4)"
    />
    <path
      d="M56 5 L63 5 C68 5 71 5.5 72 7 L78 15 L56 15 Z"
      fill="rgba(200, 200, 255, 0.4)"
    />
    
    {/* Боковая линия */}
    <path d="M18 28 L92 28" stroke="rgba(255,255,255,0.2)" strokeWidth="0.5" />
    
    {/* Колёса */}
    <ellipse cx="30" cy="42" rx="10" ry="10" fill="#1a1a2e" />
    <ellipse cx="30" cy="42" rx="7" ry="7" fill="#2d2d4a" />
    <ellipse cx="30" cy="42" rx="3" ry="3" fill="#4a4a6a" />
    
    <ellipse cx="90" cy="42" rx="10" ry="10" fill="#1a1a2e" />
    <ellipse cx="90" cy="42" rx="7" ry="7" fill="#2d2d4a" />
    <ellipse cx="90" cy="42" rx="3" ry="3" fill="#4a4a6a" />
    
    {/* Фары */}
    <ellipse cx="12" cy="34" rx="3" ry="2" fill="#fef08a" />
    <ellipse cx="107" cy="34" rx="2" ry="2" fill="#fca5a5" />
    
    {/* Блик на кузове */}
    <path d="M25 20 L85 20" stroke="rgba(255,255,255,0.3)" strokeWidth="1" strokeLinecap="round" />
  </svg>
)

// Комфорт - Седан среднего класса (как Skoda Octavia, Toyota Camry)
export const ComfortCar: React.FC<CarIconProps> = ({ className = '', size = 80, color = '#a78bfa' }) => (
  <svg
    width={size}
    height={size * 0.4}
    viewBox="0 0 130 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Тень */}
    <ellipse cx="65" cy="48" rx="55" ry="2" fill="rgba(0,0,0,0.15)" />
    
    {/* Кузов */}
    <path
      d="M8 34 L16 20 C18 16 24 14 30 14 L85 14 C91 14 97 16 100 20 L112 34 L118 34 C121 34 123 36 123 38 L123 40 C123 42 121 44 118 44 L12 44 C9 44 7 42 7 40 L7 38 C7 36 8 34 8 34 Z"
      fill={color}
    />
    
    {/* Крыша - более плавная */}
    <path
      d="M30 14 L40 4 C42 2 48 1 56 1 L70 1 C78 1 84 2 86 4 L96 14"
      fill={color}
      opacity="0.85"
    />
    
    {/* Окна панорамные */}
    <path
      d="M35 13 L42 5 C43 3.5 47 3 54 3 L62 3 L62 13 Z"
      fill="rgba(200, 200, 255, 0.45)"
    />
    <path
      d="M64 3 L72 3 C79 3 83 3.5 84 5 L91 13 L64 13 Z"
      fill="rgba(200, 200, 255, 0.45)"
    />
    
    {/* Боковые окна */}
    <path d="M20 18 L20 28 L34 28 L34 14" fill="rgba(200, 200, 255, 0.3)" />
    <path d="M92 14 L92 28 L106 28 L106 18" fill="rgba(200, 200, 255, 0.3)" />
    
    {/* Хромированная полоса */}
    <path d="M15 30 L111 30" stroke="rgba(255,255,255,0.25)" strokeWidth="1" />
    
    {/* Колёса */}
    <ellipse cx="32" cy="44" rx="11" ry="11" fill="#1a1a2e" />
    <ellipse cx="32" cy="44" rx="8" ry="8" fill="#2d2d4a" />
    <ellipse cx="32" cy="44" rx="3.5" ry="3.5" fill={color} opacity="0.5" />
    
    <ellipse cx="98" cy="44" rx="11" ry="11" fill="#1a1a2e" />
    <ellipse cx="98" cy="44" rx="8" ry="8" fill="#2d2d4a" />
    <ellipse cx="98" cy="44" rx="3.5" ry="3.5" fill={color} opacity="0.5" />
    
    {/* Фары */}
    <path d="M7 32 L12 30 L14 34 L10 38 Z" fill="#fef08a" />
    <path d="M116 30 L121 32 L118 38 L114 34 Z" fill="#fca5a5" />
    
    {/* Блик */}
    <path d="M30 16 L95 16" stroke="rgba(255,255,255,0.35)" strokeWidth="1" strokeLinecap="round" />
  </svg>
)

// Комфорт+ - Бизнес седан (как Toyota Camry, Kia K5)
export const ComfortPlusCar: React.FC<CarIconProps> = ({ className = '', size = 80, color = '#a78bfa' }) => (
  <svg
    width={size}
    height={size * 0.4}
    viewBox="0 0 140 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Тень */}
    <ellipse cx="70" cy="50" rx="58" ry="2" fill="rgba(0,0,0,0.18)" />
    
    {/* Кузов - более агрессивный */}
    <path
      d="M6 35 L16 18 C19 13 26 11 34 11 L95 11 C103 11 110 13 114 18 L128 35 L132 35 C135 35 137 37 137 39 L137 42 C137 44 135 46 132 46 L8 46 C5 46 3 44 3 42 L3 39 C3 37 5 35 6 35 Z"
      fill={color}
    />
    
    {/* Крыша спортивная */}
    <path
      d="M34 11 L46 2 C48 0 56 -1 65 -1 L75 -1 C84 -1 92 0 94 2 L106 11"
      fill={color}
      opacity="0.9"
    />
    
    {/* Окна */}
    <path
      d="M40 10 L48 3 C50 1.5 55 1 63 1 L69 1 L69 10 Z"
      fill="rgba(200, 200, 255, 0.5)"
    />
    <path
      d="M71 1 L77 1 C85 1 90 1.5 92 3 L100 10 L71 10 Z"
      fill="rgba(200, 200, 255, 0.5)"
    />
    
    {/* Акцентная линия */}
    <path d="M12 32 L128 32" stroke={color} strokeWidth="2" opacity="0.6" />
    <path d="M20 32 L120 32" stroke="rgba(255,255,255,0.2)" strokeWidth="0.5" />
    
    {/* Колёса - спортивные */}
    <ellipse cx="36" cy="46" rx="12" ry="12" fill="#0f0f1f" />
    <ellipse cx="36" cy="46" rx="9" ry="9" fill="#1a1a2e" />
    <ellipse cx="36" cy="46" rx="5" ry="5" fill={color} opacity="0.4" />
    <ellipse cx="36" cy="46" rx="2" ry="2" fill={color} opacity="0.7" />
    
    <ellipse cx="104" cy="46" rx="12" ry="12" fill="#0f0f1f" />
    <ellipse cx="104" cy="46" rx="9" ry="9" fill="#1a1a2e" />
    <ellipse cx="104" cy="46" rx="5" ry="5" fill={color} opacity="0.4" />
    <ellipse cx="104" cy="46" rx="2" ry="2" fill={color} opacity="0.7" />
    
    {/* LED фары */}
    <path d="M3 33 L10 30 L14 36 L8 40 Z" fill="#fef08a" />
    <path d="M130 30 L137 33 L132 40 L126 36 Z" fill="#fca5a5" />
    
    {/* Блики */}
    <path d="M35 12 L105 12" stroke="rgba(255,255,255,0.4)" strokeWidth="1" strokeLinecap="round" />
  </svg>
)

// Business - Премиум седан (тёмный, как Mercedes E-class, BMW 5)
export const BusinessCar: React.FC<CarIconProps> = ({ className = '', size = 80 }) => (
  <svg
    width={size}
    height={size * 0.4}
    viewBox="0 0 145 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Тень */}
    <ellipse cx="72" cy="52" rx="60" ry="2.5" fill="rgba(0,0,0,0.25)" />
    
    {/* Кузов - тёмный премиум */}
    <path
      d="M5 36 L18 16 C22 10 30 8 40 8 L100 8 C110 8 118 10 122 16 L138 36 L140 36 C143 36 145 38 145 40 L145 44 C145 46 143 48 140 48 L5 48 C2 48 0 46 0 44 L0 40 C0 38 2 36 5 36 Z"
      fill="#1e1e3f"
    />
    
    {/* Крыша элегантная */}
    <path
      d="M40 8 L52 0 C54 -2 62 -3 72 -3 L78 -3 C88 -3 96 -2 98 0 L110 8"
      fill="#2d2d5a"
    />
    
    {/* Тонированные окна */}
    <path
      d="M46 7 L54 1 C56 -0.5 61 -1 70 -1 L74 -1 L74 7 Z"
      fill="rgba(139, 92, 246, 0.25)"
    />
    <path
      d="M76 -1 L80 -1 C89 -1 94 -0.5 96 1 L104 7 L76 7 Z"
      fill="rgba(139, 92, 246, 0.25)"
    />
    
    {/* Акцентная линия */}
    <path d="M10 34 L135 34" stroke="#8b5cf6" strokeWidth="1.5" />
    
    {/* Премиум колёса */}
    <ellipse cx="40" cy="48" rx="13" ry="13" fill="#0a0a15" />
    <ellipse cx="40" cy="48" rx="10" ry="10" fill="#1a1a2e" />
    <ellipse cx="40" cy="48" rx="5" ry="5" fill="#8b5cf6" opacity="0.5" />
    <ellipse cx="40" cy="48" rx="2.5" ry="2.5" fill="#c4b5fd" />
    
    <ellipse cx="108" cy="48" rx="13" ry="13" fill="#0a0a15" />
    <ellipse cx="108" cy="48" rx="10" ry="10" fill="#1a1a2e" />
    <ellipse cx="108" cy="48" rx="5" ry="5" fill="#8b5cf6" opacity="0.5" />
    <ellipse cx="108" cy="48" rx="2.5" ry="2.5" fill="#c4b5fd" />
    
    {/* LED фары */}
    <path d="M0 34 L8 30 L12 36 L6 42 Z" fill="#fef08a" />
    <path d="M0 34 L5 32 L7 36 L3 39 Z" fill="white" opacity="0.8" />
    <path d="M137 30 L145 34 L139 42 L133 36 Z" fill="#fca5a5" />
    
    {/* Хром детали */}
    <path d="M50 0 L100 0" stroke="rgba(255,255,255,0.5)" strokeWidth="1" strokeLinecap="round" />
    <rect x="0" y="40" width="4" height="1" fill="rgba(139,92,246,0.5)" rx="0.5" />
    <rect x="141" y="40" width="4" height="1" fill="rgba(139,92,246,0.5)" rx="0.5" />
  </svg>
)

// Premier/VIP - Люксовый седан (как Mercedes S-class, BMW 7)
export const PremierCar: React.FC<CarIconProps> = ({ className = '', size = 80 }) => (
  <svg
    width={size}
    height={size * 0.4}
    viewBox="0 0 160 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Тень */}
    <ellipse cx="80" cy="54" rx="68" ry="2.5" fill="rgba(0,0,0,0.3)" />
    
    {/* Удлинённый кузов */}
    <path
      d="M4 38 L20 14 C24 8 34 5 46 5 L115 5 C127 5 137 8 140 14 L156 38 L158 38 C161 38 163 40 163 42 L163 46 C163 48 161 50 158 50 L2 50 C-1 50 -3 48 -3 46 L-3 42 C-3 40 1 38 4 38 Z"
      fill="#0f0f24"
    />
    
    {/* Крыша длинная */}
    <path
      d="M46 5 L58 -3 C60 -5 70 -6 80 -6 L85 -6 C95 -6 105 -5 107 -3 L119 5"
      fill="#1a1a3a"
    />
    
    {/* Панорамные окна */}
    <path
      d="M52 4 L60 -2 C62 -3.5 68 -4 78 -4 L82 -4 L82 4 Z"
      fill="rgba(139, 92, 246, 0.2)"
    />
    <path
      d="M84 -4 L87 -4 C97 -4 103 -3.5 105 -2 L113 4 L84 4 Z"
      fill="rgba(139, 92, 246, 0.2)"
    />
    
    {/* Боковые окна длинные */}
    <path d="M28 8 L28 26 L50 26 L50 5" fill="rgba(139, 92, 246, 0.15)" />
    <path d="M115 5 L115 26 L137 26 L137 8" fill="rgba(139, 92, 246, 0.15)" />
    
    {/* Золотая акцентная линия */}
    <path d="M8 36 L152 36" stroke="url(#premierGradient)" strokeWidth="2" />
    <defs>
      <linearGradient id="premierGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#a78bfa" />
        <stop offset="50%" stopColor="#c4b5fd" />
        <stop offset="100%" stopColor="#8b5cf6" />
      </linearGradient>
    </defs>
    
    {/* Люксовые колёса */}
    <ellipse cx="44" cy="50" rx="14" ry="14" fill="#050510" />
    <ellipse cx="44" cy="50" rx="11" ry="11" fill="#1a1a2e" />
    <ellipse cx="44" cy="50" rx="6" ry="6" fill="#8b5cf6" opacity="0.4" />
    <ellipse cx="44" cy="50" rx="3" ry="3" fill="#e9d5ff" />
    
    <ellipse cx="120" cy="50" rx="14" ry="14" fill="#050510" />
    <ellipse cx="120" cy="50" rx="11" ry="11" fill="#1a1a2e" />
    <ellipse cx="120" cy="50" rx="6" ry="6" fill="#8b5cf6" opacity="0.4" />
    <ellipse cx="120" cy="50" rx="3" ry="3" fill="#e9d5ff" />
    
    {/* Премиум фары */}
    <path d="M-3 36 L8 30 L14 38 L4 46 Z" fill="#fef08a" />
    <path d="M-3 36 L5 33 L8 38 L2 42 Z" fill="white" opacity="0.9" />
    <path d="M152 30 L163 36 L156 46 L146 38 Z" fill="#fca5a5" />
    
    {/* Хром */}
    <path d="M60 -4 L105 -4" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)

// Детский тариф - Минивэн (как Kia Carnival)
export const ChildCar: React.FC<CarIconProps> = ({ className = '', size = 80, color = '#a78bfa' }) => (
  <svg
    width={size}
    height={size * 0.45}
    viewBox="0 0 140 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Тень */}
    <ellipse cx="70" cy="58" rx="58" ry="2" fill="rgba(0,0,0,0.18)" />
    
    {/* Высокий кузов минивэна */}
    <path
      d="M8 42 L16 24 C18 18 26 14 36 14 L105 14 C115 14 123 18 125 24 L132 42 L135 42 C138 42 140 44 140 46 L140 50 C140 52 138 54 135 54 L5 54 C2 54 0 52 0 50 L0 46 C0 44 2 42 5 42 Z"
      fill={color}
    />
    
    {/* Высокая крыша */}
    <path
      d="M24 14 L24 4 C24 1 28 -1 36 -1 L105 -1 C113 -1 117 1 117 4 L117 14"
      fill={color}
      opacity="0.9"
    />
    
    {/* Большие окна */}
    <rect x="28" y="2" width="22" height="11" rx="1" fill="rgba(200, 200, 255, 0.45)" />
    <rect x="52" y="2" width="18" height="11" rx="1" fill="rgba(200, 200, 255, 0.45)" />
    <rect x="72" y="2" width="22" height="11" rx="1" fill="rgba(200, 200, 255, 0.45)" />
    <rect x="96" y="2" width="18" height="11" rx="1" fill="rgba(200, 200, 255, 0.45)" />
    
    {/* Боковые окна */}
    <rect x="14" y="18" width="18" height="14" rx="1" fill="rgba(200, 200, 255, 0.35)" />
    <rect x="108" y="18" width="18" height="14" rx="1" fill="rgba(200, 200, 255, 0.35)" />
    
    {/* Индикатор детского кресла */}
    <circle cx="70" cy="6" r="6" fill="#10b981" />
    <path d="M67 6 L69 8.5 L74 3.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    
    {/* Колёса */}
    <ellipse cx="34" cy="54" rx="12" ry="12" fill="#1a1a2e" />
    <ellipse cx="34" cy="54" rx="9" ry="9" fill="#2d2d4a" />
    <ellipse cx="34" cy="54" rx="4" ry="4" fill={color} opacity="0.5" />
    
    <ellipse cx="106" cy="54" rx="12" ry="12" fill="#1a1a2e" />
    <ellipse cx="106" cy="54" rx="9" ry="9" fill="#2d2d4a" />
    <ellipse cx="106" cy="54" rx="4" ry="4" fill={color} opacity="0.5" />
    
    {/* Фары */}
    <rect x="0" y="40" width="8" height="5" rx="1" fill="#fef08a" />
    <rect x="132" y="40" width="8" height="5" rx="1" fill="#fca5a5" />
    
    {/* Сдвижная дверь */}
    <path d="M50 14 L50 36" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
    <path d="M90 14 L90 36" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
  </svg>
)

// Elite/Ultimate - Лимузин представительского класса
export const EliteCar: React.FC<CarIconProps> = ({ className = '', size = 80 }) => (
  <svg
    width={size}
    height={size * 0.38}
    viewBox="0 0 180 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Тень */}
    <ellipse cx="90" cy="56" rx="78" ry="2.5" fill="rgba(0,0,0,0.35)" />
    
    {/* Длинный кузов лимузина */}
    <path
      d="M3 40 L22 12 C26 6 38 3 52 3 L130 3 C144 3 156 6 160 12 L177 40 L180 40 C183 40 185 42 185 44 L185 48 C185 50 183 52 180 52 L0 52 C-3 52 -5 50 -5 48 L-5 44 C-5 42 0 40 3 40 Z"
      fill="#0a0a18"
    />
    
    {/* Крыша */}
    <path
      d="M52 3 L66 -6 C68 -8 80 -9 92 -9 L98 -9 C110 -9 122 -8 124 -6 L138 3"
      fill="#151530"
    />
    
    {/* Окна */}
    <path d="M60 2 L68 -4 C70 -6 78 -7 90 -7 L95 -7 L95 2 Z" fill="rgba(139, 92, 246, 0.18)" />
    <path d="M97 -7 L102 -7 C114 -7 122 -6 124 -4 L132 2 L97 2 Z" fill="rgba(139, 92, 246, 0.18)" />
    
    {/* Боковые окна */}
    <path d="M32 6 L32 28 L58 28 L58 3" fill="rgba(139, 92, 246, 0.12)" />
    <path d="M62 3 L62 28 L88 28 L88 0" fill="rgba(139, 92, 246, 0.12)" />
    <path d="M92 0 L92 28 L118 28 L118 3" fill="rgba(139, 92, 246, 0.12)" />
    <path d="M122 3 L122 28 L148 28 L148 6" fill="rgba(139, 92, 246, 0.12)" />
    
    {/* Платиновая линия */}
    <path d="M6 38 L174 38" stroke="url(#eliteGradient)" strokeWidth="2.5" />
    <defs>
      <linearGradient id="eliteGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#c4b5fd" />
        <stop offset="50%" stopColor="#ffffff" />
        <stop offset="100%" stopColor="#a78bfa" />
      </linearGradient>
    </defs>
    
    {/* Колёса */}
    <ellipse cx="50" cy="52" rx="15" ry="15" fill="#030308" />
    <ellipse cx="50" cy="52" rx="12" ry="12" fill="#1a1a2e" />
    <ellipse cx="50" cy="52" rx="6" ry="6" fill="#8b5cf6" opacity="0.35" />
    <ellipse cx="50" cy="52" rx="3" ry="3" fill="white" />
    
    <ellipse cx="135" cy="52" rx="15" ry="15" fill="#030308" />
    <ellipse cx="135" cy="52" rx="12" ry="12" fill="#1a1a2e" />
    <ellipse cx="135" cy="52" rx="6" ry="6" fill="#8b5cf6" opacity="0.35" />
    <ellipse cx="135" cy="52" rx="3" ry="3" fill="white" />
    
    {/* Премиум фары */}
    <path d="M-5 38 L10 30 L18 40 L6 50 Z" fill="#fef08a" />
    <path d="M-3 38 L7 34 L11 40 L4 46 Z" fill="white" opacity="0.95" />
    <path d="M170 30 L185 38 L174 50 L162 40 Z" fill="#fca5a5" />
    
    {/* Хром */}
    <path d="M68 -6 L124 -6" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.7" />
    <rect x="-5" y="44" width="8" height="1.5" fill="white" opacity="0.5" rx="0.75" />
    <rect x="177" y="44" width="8" height="1.5" fill="white" opacity="0.5" rx="0.75" />
  </svg>
)

// Универсальная функция получения иконки по классу тарифа
export const getCarIcon = (tariffClass: string): React.FC<CarIconProps> => {
  const icons: Record<string, React.FC<CarIconProps>> = {
    econom: EconomCar,
    comfort: ComfortCar,
    comfortplus: ComfortPlusCar,
    business: BusinessCar,
    vip: PremierCar,
    premier: PremierCar,
    ultimate: EliteCar,
    elite: EliteCar,
    maybach: EliteCar,
    child_tariff: ChildCar,
    lite_b2b: EconomCar,
    standart_b2b: ComfortCar,
    optimum_b2b: ComfortPlusCar,
    minivan: ComfortPlusCar,
    premium_van: BusinessCar,
  }
  return icons[tariffClass] || EconomCar
}

export default {
  EconomCar,
  ComfortCar,
  ComfortPlusCar,
  BusinessCar,
  PremierCar,
  ChildCar,
  EliteCar,
  getCarIcon,
}
